/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunHistoryRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunHistoryRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunHistoryRequest>): WellArchitectedFrameworkAssessmentRunHistoryRequest {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunHistoryRequest(), model);
        WellArchitectedFrameworkAssessmentRunHistoryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunHistoryRequest>): WellArchitectedFrameworkAssessmentRunHistoryRequest {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunHistoryRequest.newInstance(<WellArchitectedFrameworkAssessmentRunHistoryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunHistoryRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunHistoryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunHistoryRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunHistoryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_run_ids) {
            for (let val of this.assessment_run_ids) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    assessment_run_ids: Array<models.RecordIdentity>;

}
